import thunk from 'redux-thunk';
import {createStore, applyMiddleware, compose} from 'redux';
import combinedReducer from "../reducers/rootReducer";

export default createStore( combinedReducer,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
);